import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import PasswordDeleteButton from "@/components/PasswordDeleteButton";

export default function AdminLeads() {
    const [leads, setLeads] = useState([]);

    const load = async () => {
        const { data } = await api.get("/admin/leads");
        setLeads(data);
    };
    useEffect(() => { load(); }, []);

    return (
        <div className="p-8">
            <div>
                <div className="text-xs font-mono uppercase tracking-[0.24em] text-neutral-500">Captura</div>
                <h1 className="mt-1 font-heading font-black text-3xl tracking-tight">Leads</h1>
                <p className="mt-2 text-sm text-neutral-500 font-mono">{leads.length} registro(s)</p>
            </div>

            <div className="mt-6 bg-white border border-neutral-300 overflow-x-auto">
                <table className="w-full text-sm">
                    <thead className="bg-neutral-50 font-mono text-xs uppercase tracking-widest text-neutral-500">
                        <tr>
                            <th className="text-left p-3">E-mail</th>
                            <th className="text-left p-3">Nome</th>
                            <th className="text-left p-3">Empresa</th>
                            <th className="text-left p-3">Telefone</th>
                            <th className="text-left p-3">Mensagem</th>
                            <th className="text-left p-3">Origem</th>
                            <th className="text-left p-3">Data</th>
                            <th className="text-right p-3">Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        {leads.length === 0
                            ? <tr><td colSpan={8} className="p-12 text-center font-mono text-sm text-neutral-500">nenhum lead ainda</td></tr>
                            : leads.map((l, i) => (
                                <tr key={l.id} className={`border-t border-neutral-200 ${i % 2 ? "bg-neutral-50/50" : ""}`} data-testid={`lead-row-${l.id}`}>
                                    <td className="p-3 font-medium">{l.email}</td>
                                    <td className="p-3 text-neutral-600">{l.name || "—"}</td>
                                    <td className="p-3 text-neutral-600">{l.company || "—"}</td>
                                    <td className="p-3 font-mono text-xs">{l.phone || "—"}</td>
                                    <td className="p-3 text-neutral-600 max-w-xs truncate" title={l.message}>{l.message || "—"}</td>
                                    <td className="p-3 font-mono text-xs text-neutral-500">{l.source}</td>
                                    <td className="p-3 font-mono text-xs text-neutral-500">{new Date(l.created_at).toLocaleString("pt-BR")}</td>
                                    <td className="p-3">
                                        <div className="flex justify-end">
                                            <PasswordDeleteButton
                                                endpoint={`/admin/leads/${l.id}`}
                                                label="Lead"
                                                testId={`delete-lead-${l.id}`}
                                                onDeleted={load}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
